/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProposalFilterType = {
    Proposal: 'Proposal',
    Application: 'Application',
    Signing: 'Signing'
} as const;
export type ProposalFilterType = typeof ProposalFilterType[keyof typeof ProposalFilterType];


export function ProposalFilterTypeFromJSON(json: any): ProposalFilterType {
    return ProposalFilterTypeFromJSONTyped(json, false);
}

export function ProposalFilterTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalFilterType {
    return json as ProposalFilterType;
}

export function ProposalFilterTypeToJSON(value?: ProposalFilterType | null): any {
    return value as any;
}

